import React, { useEffect, useState } from 'react';
import { Mail } from 'lucide-react';
import { api } from '../lib/api';

/* [PATCH mail-vhod-D3 v1] ✉ oznaka: dokument je prišel po e-pošti.
   Množica ID-jev se za podjetje naloži ENKRAT (modulni predpomnilnik + ena
   sočasna zahteva za vse vrstice), osveži se po 60 s. Ob 403 (vloga brez
   dostopa) ali napaki komponenta tiho ne prikaže ničesar. */

let _cacheCompany: string | null = null;
let _cacheSet: Set<string> = new Set();
let _cacheCas = 0;
let _vTeku: Promise<Set<string>> | null = null;

async function naloziSet(companyId: string): Promise<Set<string>> {
  const zdaj = Date.now();
  if (_cacheCompany === companyId && zdaj - _cacheCas < 60000) return _cacheSet;
  if (_vTeku && _cacheCompany === companyId) return _vTeku;
  _cacheCompany = companyId;
  _vTeku = api.get(`/mail-vhod/${companyId}/dokument-idji`)
    .then(r => {
      _cacheSet = new Set<string>((r.data || []).map(String));
      _cacheCas = Date.now();
      return _cacheSet;
    })
    .catch(() => { _cacheCas = Date.now(); _cacheSet = new Set(); return _cacheSet; })
    .finally(() => { _vTeku = null; });
  return _vTeku;
}

export function MailVhodOznaka({ companyId, docId, velika }:
  { companyId: string; docId?: string | null; velika?: boolean }) {
  const [je, setJe] = useState(false);
  useEffect(() => {
    let aktiven = true;
    if (companyId && docId) naloziSet(companyId).then(s => { if (aktiven) setJe(s.has(String(docId))); });
    else setJe(false);
    return () => { aktiven = false; };
  }, [companyId, docId]);
  if (!je) return null;
  return (
    <span title="Prejeto po e-pošti (samodejni uvoz)" className="inline-flex items-center align-middle">
      <Mail className={(velika ? 'w-4 h-4' : 'w-3.5 h-3.5') + ' text-cyan-500'} />
    </span>
  );
}
